module.exports = __webpack_public_path__ + "669d0189315b75c74b45dce80aed957f.png";